import { BookerPlatformWrapperAtomPropsForTeam } from '@calcom/atoms/dist/packages/platform/atoms/booker/types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import calApi from '../../../api/calApi';
import { Booker } from '../../../LazyBooker';
import { logBookingError } from '../../../loggingUtils';
import { Booking } from '../../../types';
import { isBookingValid } from '../../../utils';
import CloseButton from '../../CloseButton';
import { Modal } from '../../Modal';
import { bookingStrings, str } from './strings';

const rescheduleStrings = bookingStrings.confirmation.reschedule;

interface RescheduleModalProps {
    bookerProps: BookerPlatformWrapperAtomPropsForTeam;
    onClose: () => void;
}

const RescheduleModal = ({ bookerProps, onClose }: RescheduleModalProps) => {
    const [rescheduleBookingData, setRescheduleBookingData] =
        useState<Booking | null>(null);
    const { bookingUid, ...rest } = bookerProps;

    useEffect(() => {
        if (bookingUid) {
            calApi
                .getBooking(bookingUid)
                .then((bookingData) => {
                    if (isBookingValid(bookingData.status)) {
                        setRescheduleBookingData(bookingData);
                    } else {
                        onClose();
                    }
                })
                .catch((err) => {
                    logBookingError(
                        'Failed to get booking data (reschedule flow)',
                        {
                            errorMessage: err.message,
                            additionalInfoToLog: {
                                ...bookerProps,
                                bookingUid,
                            },
                        }
                    );
                });
        }
    }, []);

    if (!rescheduleBookingData) {
        return null;
    }

    return (
        <Modal
            width='65vw'
            header={
                <Header>
                    <span>
                        {str(rescheduleStrings.title)}
                    </span>
                    <CloseButton onClick={onClose} />
                </Header>
            }
            dataAuto='ssr-cal-booking-reschedule-modal'
        >
            <Wrapper>
                <Booker
                    {...rest}
                    rescheduleUid={bookingUid}
                    metadata={rescheduleBookingData.metadata}
                />
            </Wrapper>
        </Modal>
    );
};

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    height: 58px;
    background-color: #f5f5f7;
    line-height: 58px;
    position: relative;
    padding: 0 32px;
    font-weight: 550;
    font-size: 16px;
    span {
        width: fit-content;
    }
`;
export default RescheduleModal;
